module.exports = __webpack_public_path__ + "img/1341395826.828b990a.jpg";